<div class="pv2-page">
  <section class="pv2-shell">
    <aside class="pv2-sidebar" *ngIf="!isMobile">
      <div class="pv2-sidebar-card">
        <div class="pv2-sidebar-head">
          <h2>Cardápio</h2>
          <p>{{ statusFilteredItems.length }} produtos</p>
        </div>

        <button
          type="button"
          class="pv2-sidebar-item"
          *ngFor="let category of categoryList; trackBy: trackByLabel"
          [class.is-active]="selectedCategory === category.nome"
          (click)="selecioneCategoria(category.nome)">
          <span class="pv2-sidebar-item__icon">{{ category.emoji }}</span>
          <span class="pv2-sidebar-item__name">{{ category.nome }}</span>
          <span class="pv2-sidebar-item__count">{{ category.count }}</span>
        </button>
      </div>
    </aside>

    <main class="pv2-content">
      <div class="pv2-top-band">
        <section class="pv2-page-header">
          <div class="pv2-page-header__text">
            <h1 class="pv2-page-title">Produtos</h1>
            <p class="pv2-page-subtitle">{{ statusFilteredItems.length }} itens cadastrados</p>
          </div>
          <div class="pv2-header-actions">
            <ng-container *ngIf="!isMobile; else mobileHeaderActions">
              <button type="button" class="pv2-category-manager-btn" (click)="abraCategoriasAtalho()">
                <span class="fa fa-th-large"></span>
                <span>Categorias</span>
              </button>

              <button type="button" class="pv2-category-manager-btn" *ngIf="temModuloTabelaPrecos" (click)="abraTabelaPrecos()">
                <span class="fa fa-tags"></span>
                <span>Tabelas preços</span>
              </button>

              <div class="pv2-split-btn">
                <button type="button" class="pv2-split-btn__main" (click)="abraCriacao()">
                  <span class="fa fa-plus"></span>
                  <span>Novo Produto</span>
                </button>

                <button type="button" class="pv2-split-btn__toggle" (click)="toggleDesktopActionsDropdown()">
                  <span>Mais</span>
                  <span class="fa fa-angle-down pv2-caret" [class.is-open]="desktopActionsDropdownOpen"></span>
                </button>

                <div class="pv2-dropdown-backdrop" *ngIf="desktopActionsDropdownOpen" (click)="closeDesktopActionsDropdown()"></div>

                <div class="pv2-dropdown-menu" *ngIf="desktopActionsDropdownOpen">
                  <button
                    type="button"
                    class="pv2-dropdown-item"
                    *ngFor="let action of desktopSecondaryActions; trackBy: trackByLabel"
                    (click)="executeTopAction(action.id)">
                    <span class="fa" [ngClass]="action.icon"></span>
                    {{ action.label }}
                  </button>

                  <div class="pv2-dropdown-divider"></div>

                  <button type="button" class="pv2-dropdown-item" (click)="abraImportadores()">
                    <span class="fa fa-upload"></span>
                    <span>Importar</span>
                  </button>

                  <button type="button" class="pv2-dropdown-item pv2-dropdown-item--export" (click)="toggleExportDropdown()">
                    <span class="fa fa-download"></span>
                    <span>Exportar Cardápio</span>
                    <span class="fa fa-angle-down pv2-export-caret" [class.is-open]="exportDropdownOpen"></span>
                  </button>

                  <div class="pv2-export-menu pv2-export-menu--nested" *ngIf="exportDropdownOpen">
                    <button type="button" class="pv2-export-menu__item" (click)="downloadCardapioPDF()">
                      <span class="fas fa-file-pdf"></span>
                      <span>Cardápio em PDF</span>
                    </button>
                    <div class="pv2-export-menu__divider"></div>
                    <button type="button" class="pv2-export-menu__item" (click)="abraModalExportarProdutos()">
                      <span class="fa fa-download"></span>
                      <span>Cardápio em CSV</span>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-template #mobileHeaderActions>
              <button type="button" class="pv2-fab-categories" (click)="abraCategoriasAtalho()" title="Categorias" aria-label="Categorias">
                <span class="fa fa-th-large"></span>
              </button>
              <button
                type="button"
                class="pv2-fab-photo-toggle"
                [class.is-active]="showProductPhotos"
                [class.is-saving]="savingProductPhotosPreference"
                [disabled]="savingProductPhotosPreference"
                (click)="toggleProductPhotos()"
                [title]="showProductPhotos ? 'Ocultar fotos' : 'Mostrar fotos'"
                [attr.aria-label]="showProductPhotos ? 'Ocultar fotos' : 'Mostrar fotos'">
                <span class="fa fa-spinner fa-spin" *ngIf="savingProductPhotosPreference"></span>
                <span class="fa fa-image" *ngIf="!savingProductPhotosPreference"></span>
              </button>
              <button type="button" class="pv2-fab-more" (click)="abraMaisAcoes()">
                <span class="fa fa-ellipsis-h"></span>
              </button>
              <button type="button" class="pv2-fab-add" (click)="abraCriacao()">
                <span class="fa fa-plus"></span>
              </button>
            </ng-template>
          </div>
        </section>

        <section class="pv2-search-row">
          <label class="pv2-search pv2-search--pill" [class.is-focused]="searchFocused">
            <span class="fa fa-search"></span>
            <input
              [(ngModel)]="search"
              (ngModelChange)="onSearchChanged()"
              (focus)="searchFocused = true"
              (blur)="searchFocused = false"
              type="text"
              placeholder="Buscar produtos..."
              inputmode="search">
          </label>
        </section>

        <section class="pv2-filter-pills">
          <button type="button" class="pv2-filter-pill"
                  [class.is-active]="selectedStatusTab === 'sale'"
                  (click)="selectStatusTab(statusTabs[0])">
            Ativos
            <strong *ngIf="statusTabs[0]">{{ statusTabs[0].count }}</strong>
          </button>
          <button type="button" class="pv2-filter-pill pv2-filter-pill--inactive"
                  [class.is-active]="selectedStatusTab === 'unavailable'"
                  (click)="selectStatusTab(statusTabs[1])">
            Inativos
            <strong *ngIf="statusTabs[1]">{{ statusTabs[1].count }}</strong>
          </button>
          <span class="pv2-filter-divider"></span>
          <button type="button"
                  class="pv2-filter-pill pv2-filter-pill--filtros"
                  [class.is-active]="activeFilterCount > 0"
                  (click)="abraFiltrosAvancados()">
            <span class="fa fa-sliders-h"></span>
            Filtros
            <strong *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</strong>
          </button>

          <div class="pv2-filter-chips-right" *ngIf="activeFilterChips.length">
            <button type="button"
                    class="pv2-filter-chip-dismiss"
                    *ngFor="let chip of activeFilterChips"
                    (click)="removaChipFiltro(chip.key)">
              {{ chip.label }}
              <span class="fa fa-times"></span>
            </button>
          </div>
        </section>
      </div>

      <section class="pv2-category-row" *ngIf="isMobile">
        <div class="pv2-category-row__header">
          <span class="pv2-category-row__label">Categorias</span>
          <div class="pv2-category-row__actions">
            <button type="button"
                    class="pv2-category-row__reorder"
                    *ngIf="!isReorderMode"
                    (click)="onMobileReorderTap()">
              <span class="fa fa-sort"></span> Reordenar
            </button>
            <button type="button" class="pv2-category-row__link" (click)="abraCategoriaSheet()">
              Ver todas
            </button>
          </div>
        </div>
        <div class="pv2-category-chips">
          <button
            type="button"
            class="pv2-chip"
            *ngFor="let category of visibleCategoryChips; trackBy: trackByLabel"
            [class.is-active]="selectedCategory === category.nome"
            (click)="selecioneCategoria(category.nome)">
            {{ category.nome }}
          </button>
        </div>
      </section>


      <!-- Controles de reordenação mobile -->
      <section class="pv2-mobile-reorder-bar" *ngIf="isMobile && isReorderMode">
        <span class="pv2-reorder-category-label">{{ selectedCategory }}</span>
        <button type="button" class="pv2-btn-success" (click)="saveReorder()">
          <span class="fa fa-check"></span> Salvar
        </button>
        <button type="button" class="pv2-btn-cancel" (click)="exitReorderMode(false)">
          <span class="fa fa-times"></span> Cancelar
        </button>
      </section>

      <!-- Barra de controles de visualização e ordenação -->
      <section class="pv2-view-controls" *ngIf="!isMobile">
        <div class="pv2-view-controls__left">
          <!-- Botões de alternar visualização -->
          <div class="pv2-view-toggle">
            <button type="button"
                    class="pv2-view-toggle__btn"
                    [class.is-active]="viewMode === 'grid'"
                    (click)="altereModoVisualizacao('grid')"
                    title="Visualização em grade">
              <span class="fa fa-th"></span>
            </button>
            <button type="button"
                    class="pv2-view-toggle__btn"
                    [class.is-active]="viewMode === 'list'"
                    (click)="altereModoVisualizacao('list')"
                    title="Visualização em lista">
              <span class="fa fa-list"></span>
            </button>
          </div>

          <button
            type="button"
            class="pv2-photo-toggle"
            [class.is-active]="showProductPhotos"
            [class.is-saving]="savingProductPhotosPreference"
            [disabled]="savingProductPhotosPreference"
            (click)="toggleProductPhotos()"
            [title]="showProductPhotos ? 'Ocultar fotos' : 'Mostrar fotos'"
            [attr.aria-label]="showProductPhotos ? 'Ocultar fotos' : 'Mostrar fotos'">
            <span class="fa fa-spinner fa-spin" *ngIf="savingProductPhotosPreference"></span>
            <svg *ngIf="!savingProductPhotosPreference" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
          </button>

          <!-- Botão direto quando categoria já selecionada -->
          <button type="button"
                  class="pv2-reorder-btn"
                  *ngIf="!isReorderMode && selectedCategory !== 'Todos'"
                  (click)="reorderByCategory(selectedCategory)">
            <span class="fa fa-sort"></span>
            Reordenar Produtos
          </button>

          <!-- Dropdown quando em "Todos" -->
          <kendo-dropdownlist
            *ngIf="!isReorderMode && selectedCategory === 'Todos'"
            class="pv2-reorder-dropdown"
            [data]="categoryList.slice(1)"
            [textField]="'nome'"
            [valueField]="'nome'"
            [valuePrimitive]="true"
            [value]="null"
            [defaultItem]="{ nome: 'Reordenar categoria...', id: null, count: 0 }"
            (valueChange)="$event && $event !== 'Reordenar categoria...' && reorderByCategory($event)"
            [popupSettings]="{ animate: true }"
          ></kendo-dropdownlist>

          <!-- Controles de reordenação -->
          <div class="pv2-reorder-controls" *ngIf="isReorderMode">
            <span class="pv2-reorder-category-label">{{ selectedCategory }}</span>
            <button type="button" class="pv2-btn-success" (click)="saveReorder()">
              <span class="fa fa-check"></span>
              Salvar Ordem
            </button>
            <button type="button" class="pv2-btn-cancel" (click)="exitReorderMode(false)">
              <span class="fa fa-times"></span>
              Cancelar
            </button>
          </div>
        </div>

        <div class="pv2-view-controls__right">
          <!-- Ordenação automática para grid -->
          <div class="pv2-grid-sort" *ngIf="viewMode === 'grid'">
            <button type="button"
                    class="pv2-sort-chip"
                    *ngFor="let opt of gridSortOptions"
                    [class.is-active]="gridSortField === opt.value"
                    (click)="onSortChipClick(opt.value)">
              {{ opt.text }}
              <span class="fa fa-sort-asc" *ngIf="gridSortField === opt.value && gridSortDirection === 'asc'"></span>
              <span class="fa fa-sort-desc" *ngIf="gridSortField === opt.value && gridSortDirection === 'desc'"></span>
            </button>
          </div>
        </div>
      </section>

      <section class="pv2-bulk-bar" *ngIf="bulkMode && selectedIds.length && !isMobile">
        <span>{{ selectedIds.length }} selecionado(s)</span>
        <button type="button" class="pv2-bulk-bar__btn" (click)="bulkActivate(true)">Ativar</button>
        <button type="button" class="pv2-bulk-bar__btn" (click)="bulkActivate(false)">Desativar</button>
        <button type="button" class="pv2-bulk-bar__btn" (click)="bulkDuplicate()">Duplicar</button>
        <select class="pv2-bulk-select" [(ngModel)]="bulkCategoryId" (ngModelChange)="bulkMoveCategory($event)">
          <option value="">Mover categoria</option>
          <option *ngFor="let category of categoryList.slice(1)" [value]="category.id">{{ category.nome }}</option>
        </select>
      </section>

      <section class="pv2-grid" [class.is-list]="viewMode === 'list' || isMobile">
        <ng-container *ngIf="!loading; else loadingState">
          <article
            class="pv2-product-card"
            *ngFor="let item of displayItems; trackBy: trackByItem"
            [class.is-list]="viewMode === 'list' || isMobile"
            [class.is-photo-hidden]="!showProductPhotos"
            [class.pv2-reorder-flash]="lastMovedIds.has(item.id)"
            [class.pv2-reorder-flash--swap]="lastSwappedId === item.id"
            (click)="onProductCardPressed(item, $event)">

            <label class="pv2-select" *ngIf="bulkMode && !isMobile" (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="bulkSelection[item.id]" (change)="toggleBulkItem(item, $event)">
            </label>

            <!-- Botões de reordenação (apenas em modo lista) -->
            <div class="pv2-reorder-buttons" *ngIf="(viewMode === 'list' || isMobile) && isReorderMode">
              <!-- Seta indicativa de direção -->
              <span class="pv2-move-arrow pv2-move-arrow--up"
                    *ngIf="lastMovedIds.has(item.id) && lastSwappedId !== item.id && lastMoveDirection === 'up'">
                <i class="fa fa-arrow-up"></i>
              </span>
              <span class="pv2-move-arrow pv2-move-arrow--down"
                    *ngIf="lastMovedIds.has(item.id) && lastSwappedId !== item.id && lastMoveDirection === 'down'">
                <i class="fa fa-arrow-down"></i>
              </span>
              <span class="pv2-move-arrow pv2-move-arrow--down"
                    *ngIf="lastSwappedId === item.id && lastMoveDirection === 'up'">
                <i class="fa fa-arrow-down"></i>
              </span>
              <span class="pv2-move-arrow pv2-move-arrow--up"
                    *ngIf="lastSwappedId === item.id && lastMoveDirection === 'down'">
                <i class="fa fa-arrow-up"></i>
              </span>

              <span class="pv2-reorder-index">{{ getReorderIndex(item) }}</span>
              <button type="button"
                      class="pv2-reorder-btn-small"
                      *ngIf="!isMobile"
                      (click)="moveProductToTop(item); $event.stopPropagation()"
                      [disabled]="getReorderItems()[0]?.id === item.id"
                      title="Mover para o topo">
                <span class="fa fa-angle-double-up"></span>
              </button>
              <button type="button"
                      class="pv2-reorder-btn-small"
                      (click)="moveProductUp(item); $event.stopPropagation()"
                      [disabled]="getReorderItems()[0]?.id === item.id"
                      title="Subir">
                <span class="fa fa-angle-up"></span>
              </button>
              <button type="button"
                      class="pv2-reorder-btn-small"
                      (click)="moveProductDown(item); $event.stopPropagation()"
                      [disabled]="getReorderItems()[getReorderItems().length - 1]?.id === item.id"
                      title="Descer">
                <span class="fa fa-angle-down"></span>
              </button>
              <button type="button"
                      class="pv2-reorder-btn-small"
                      *ngIf="!isMobile"
                      (click)="moveProductToBottom(item); $event.stopPropagation()"
                      [disabled]="getReorderItems()[getReorderItems().length - 1]?.id === item.id"
                      title="Mover para o final">
                <span class="fa fa-angle-double-down"></span>
              </button>
            </div>

            <span class="pv2-status-dot"
                  [class.is-draft]="item.status === 'draft'"
                  [class.is-photo-hidden]="!showProductPhotos"></span>

            <div class="pv2-product-card__hero" *ngIf="showProductPhotos">
              <div class="pv2-product-media" [class.is-placeholder]="!item.showImage">
                <img
                  [hidden]="!item.showImage"
                  [src]="item.image"
                  [alt]="item.name"
                  (error)="onImageError(item, $event)">
                <span class="pv2-product-media__placeholder" [hidden]="item.showImage">
                  {{ item.displayPlaceholderToken }}
                </span>
              </div>
            </div>

              <div class="pv2-product-card__body">
                <div class="pv2-product-card__head">
                  <div class="pv2-product-card__text">
                    <div class="pv2-product-card__title-row">
                      <h3>{{ item.name }}</h3>
                    </div>
                    <p>{{ item.category }}</p>
                  </div>

                  <button type="button" class="pv2-card-menu" (click)="abraAcoes(item, $event)">
                    <span class="fa fa-ellipsis-v"></span>
                  </button>
                </div>

              <div class="pv2-product-card__footer">
                <div class="pv2-product-card__footer-main">
                  <button type="button" class="pv2-complements-chip" (click)="abraComplementos(item, $event)">
                    <span class="pv2-complements-chip__plus">+</span>
                    <span class="pv2-complements-chip__count" *ngIf="item.groupCount">{{ item.groupCount }}</span>
                    <span>{{ item.complementsLabel }}</span>
                  </button>

                  <div class="pv2-price-slot" (click)="editePreco(item, $event)">
                    <ng-container *ngIf="editingPriceId !== item.id; else priceEditor">
                      <button *ngIf="canEditInlinePrice(item); else readonlyPrice"
                              type="button"
                              class="pv2-inline-price"
                              [class.is-saving]="savingPriceId === item.id"
                              kendoTooltip
                              title="Clique para editar o preço">
                        {{ getCatalogPriceLabel(item) }}
                        <i class="fa fa-pencil pv2-inline-price__edit-icon"></i>
                      </button>
                      <ng-template #readonlyPrice>
                        <span class="pv2-inline-price"
                              [class.has-starting-price]="item.hasStartingPrice">
                          <span *ngIf="item.hasStartingPrice" class="pv2-inline-price__eyebrow">
                            {{ getCatalogStartingPriceEyebrow(item) }}
                          </span>
                          <span class="pv2-inline-price__value">
                            {{ item.hasStartingPrice ? getCatalogPriceValue(item) : getCatalogPriceLabel(item) }}
                          </span>
                        </span>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #priceEditor>
              <div class="pv2-price-editor" (click)="$event.stopPropagation()">
                <span class="pv2-price-editor__prefix">R$</span>
                <input
                  class="pv2-price-input"
                  [(ngModel)]="editingPriceValue"
                  type="text"
                  inputmode="decimal"
                  (blur)="confirmePreco(item)"
                  (keydown.enter)="confirmePreco(item)"
                  (keydown.escape)="cancelePreco()">
              </div>
            </ng-template>
          </article>

          <div class="pv2-empty" *ngIf="selectedStatusTab === 'stock'">
            <h3>Reposição de estoque</h3>
            <p>Esse bloco ainda não foi migrado para a V2. Use as ferramentas avançadas para ver os alertas atuais.</p>
          </div>

          <div class="pv2-empty" *ngIf="selectedStatusTab !== 'stock' && !filteredItems.length">
            <h3>Nenhum produto encontrado</h3>
            <p>Ajuste a busca ou a categoria selecionada.</p>
          </div>
        </ng-container>
      </section>

      <ng-template #loadingState>
        <section class="pv2-grid">
          <div class="pv2-product-card is-loading" [class.is-photo-hidden]="!showProductPhotos" *ngFor="let skeleton of [1,2,3,4,5,6,7,8]">
            <div class="pv2-skel pv2-skel-hero" *ngIf="showProductPhotos"></div>
            <div class="pv2-skel pv2-skel-line"></div>
            <div class="pv2-skel pv2-skel-line pv2-skel-line-md"></div>
            <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
          </div>
        </section>
      </ng-template>
    </main>
  </section>

  <div class="pv2-drawer-scrim" *ngIf="drawerOpen" (click)="onDrawerClosed()"></div>

  <aside class="pv2-editor-drawer"
         [class.is-batch-options-mode]="drawerOptionMode === 'batch-price'"
         *ngIf="drawerOpen">
    <app-tela-editor-produto-v2
      [embedded]="true"
      [productId]="drawerProductId"
      [newProductType]="drawerNewProductType"
      [pizzaTemplateId]="drawerPizzaTemplateId"
      [surfaceMode]="drawerSurface"
      [focusGroupId]="drawerFocusGroupId"
      [groupDraftMode]="drawerGroupDraftMode"
      [requestedOptionMode]="drawerOptionMode"
      [startWithPreview]="drawerStartWithPreview"
      [startWithLibrary]="drawerStartWithLibrary"
      [scrollToSection]="drawerScrollToSection"
      (closeRequested)="onDrawerClosed()"
      (productResolved)="onDrawerProductResolved($event)"
      (productPersisted)="onDrawerProductPersisted()"
      (surfaceChangeRequested)="onDrawerSurfaceChange($event)">
    </app-tela-editor-produto-v2>
  </aside>

  <div class="pv2-overlay" *ngIf="actionSheetOpen || moveCategoryItem || createChooserOpen || importChooserOpen || exportChooserOpen || moreActionsOpen || categorySheetOpen || advancedFiltersOpen" (click)="closeActionSheet(); fecheMoverCategoria(); fecheCriacao(); fecheImportadores(); fecheExportadores(); fecheMaisAcoes(); fecheCategoriaSheet(); fecheFiltrosAvancados()"></div>

  <section class="pv2-sheet" *ngIf="actionSheetOpen && actionItem">
    <div class="pv2-sheet-drag-handle"></div>
    <header>
      <div>
        <h3>{{ actionItem.name }}</h3>
        <p>{{ actionItem.category }} • {{ getCatalogPriceLabel(actionItem) }}</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="closeActionSheet()"><span class="fa fa-times"></span></button>
    </header>

    <button type="button" class="pv2-sheet-action" (click)="toggleStatus(actionItem)">
      <span class="fa fa-clock-o"></span> {{ actionItem.status === 'active' ? 'Desativar' : 'Ativar' }}
    </button>
    <button type="button" class="pv2-sheet-action" (click)="duplicateItem(actionItem)"><span class="fa fa-clone"></span> Duplicar produto</button>
    <button type="button" class="pv2-sheet-action" (click)="abraMoverCategoria(actionItem)"><span class="fa fa-share"></span> Mover de categoria</button>
    <button type="button" class="pv2-sheet-action" (click)="abraComplementos(actionItem)"><span class="fa fa-puzzle-piece"></span> Complementos</button>
    <button type="button" class="pv2-sheet-action" (click)="abraEditor(actionItem, { preview: 1 })"><span class="fa fa-eye"></span> Preview rápido</button>
    <button type="button" class="pv2-sheet-action" *ngIf="temModuloTabelaPrecos" (click)="abraTabelaPrecosProduto(actionItem)"><span class="fa fa-tags"></span>Tabelas de preços</button>
    <button type="button" class="pv2-sheet-action is-danger" (click)="removeItem(actionItem)"><span class="fa fa-trash"></span> Excluir produto</button>

    <footer class="pv2-sheet-footer">
      <button type="button" class="pv2-sheet-footer__clear" (click)="closeActionSheet()">Fechar</button>
      <button type="button" class="pv2-sheet-footer__apply" (click)="abraEditor(actionItem)">Editar produto</button>
    </footer>
  </section>

  <section class="pv2-sheet" *ngIf="moveCategoryItem">
    <header>
      <div>
        <h3>Mover categoria</h3>
        <p>{{ moveCategoryItem.name }}</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheMoverCategoria()"><span class="fa fa-times"></span></button>
    </header>

    <button type="button" class="pv2-sheet-action" *ngFor="let category of categoryList.slice(1)" (click)="apliqueCategoria(category)">
      {{ category.nome }}
    </button>
  </section>

  <section class="pv2-sheet pv2-sheet--create" *ngIf="createChooserOpen">
    <header>
      <div>
        <h3>Novo produto</h3>
        <p>Escolha o tipo de produto que deseja criar</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheCriacao()"><span class="fa fa-times"></span></button>
    </header>

    <div class="pv2-create-options">
      <button type="button" class="pv2-create-card" (click)="crieProduto('normal')">
        <span class="pv2-create-card__icon pv2-create-card__icon--normal">
          <span class="fa fa-cube"></span>
        </span>
        <div class="pv2-create-card__text">
          <strong>Produto normal</strong>
          <small>Hamburguer, bebida, sobremesa, etc.</small>
        </div>
      </button>

      <button type="button" class="pv2-create-card"
              *ngFor="let tpl of pizzaTemplates"
              (click)="crieProduto('pizza', tpl.id)">
        <span class="pv2-create-card__icon pv2-create-card__icon--pizza">
          <span class="fa fa-pizza-slice"></span>
        </span>
        <div class="pv2-create-card__text">
          <strong>Sabor de {{ tpl.nome || tpl.identificador || 'Pizza' }}</strong>
          <small>Sabor com tamanhos, massas e bordas</small>
        </div>
      </button>

      <button type="button" class="pv2-create-card" (click)="crieProduto('brindefidelidade')">
        <span class="pv2-create-card__icon pv2-create-card__icon--brinde">
          <span class="fa fa-gift"></span>
        </span>
        <div class="pv2-create-card__text">
          <strong>Brinde fidelidade</strong>
          <small>Produto resgatavel com pontos</small>
        </div>
      </button>
    </div>
  </section>

  <section class="pv2-sheet pv2-sheet--imports" *ngIf="importChooserOpen">
    <header>
      <div>
        <h3>Importar cardápio</h3>
        <p>Escolha a fonte que já existia na V1 para continuar o fluxo.</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheImportadores()"><span class="fa fa-times"></span></button>
    </header>

    <div class="pv2-import-groups">
      <section class="pv2-import-group" *ngFor="let group of importerGroups; trackBy: trackByLabel">
        <div class="pv2-import-group__head">
          <h4>{{ group.title }}</h4>
          <p *ngIf="group.caption">{{ group.caption }}</p>
        </div>

        <button type="button" class="pv2-sheet-action pv2-import-action" *ngFor="let item of group.items; trackBy: trackByLabel" (click)="abraImportador(item.id)">
          <span class="pv2-import-action__icon fa" [ngClass]="item.icon"></span>
          <span class="pv2-import-action__body">
            <strong>{{ item.label }}</strong>
            <small>{{ item.description }}</small>
          </span>
          <span class="fa fa-angle-right pv2-import-action__arrow"></span>
        </button>
      </section>
    </div>
  </section>

  <section class="pv2-sheet pv2-sheet--exports" *ngIf="exportChooserOpen">
    <header>
      <div>
        <h3>Exportar cardápio</h3>
        <p>Escolha o formato que deseja baixar.</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheExportadores()"><span class="fa fa-times"></span></button>
    </header>

    <div class="pv2-create-options pv2-more-options">
      <button type="button" class="pv2-create-card pv2-more-card" (click)="downloadCardapioPDF()">
        <span class="pv2-create-card__icon pv2-create-card__icon--orange">
          <span class="fas fa-file-pdf"></span>
        </span>
        <div class="pv2-create-card__text">
          <strong>Cardápio em PDF</strong>
          <small>Baixe a versão em PDF usada na V1.</small>
        </div>
      </button>

      <button type="button" class="pv2-create-card pv2-more-card" (click)="abraModalExportarProdutos()">
        <span class="pv2-create-card__icon pv2-create-card__icon--green">
          <span class="fa fa-download"></span>
        </span>
        <div class="pv2-create-card__text">
          <strong>Cardápio em CSV</strong>
          <small>Abra o exportador legado para baixar em CSV.</small>
        </div>
      </button>
    </div>
  </section>

  <section class="pv2-sheet pv2-sheet--more" *ngIf="moreActionsOpen">
    <header>
      <div>
        <h3>Mais ações</h3>
        <p>Atalhos rápidos para ferramentas do catálogo</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheMaisAcoes()"><span class="fa fa-times"></span></button>
    </header>

    <div class="pv2-create-options pv2-more-options">
      <button type="button"
              class="pv2-create-card pv2-more-card"
              *ngFor="let action of mobileSecondaryActions"
              [hidden]="action.id === 'price-tables' && !temModuloTabelaPrecos"
              (click)="executeTopAction(action.id)">
        <span class="pv2-create-card__icon"
              [ngClass]="'pv2-create-card__icon--' + action.tone">
          <span class="fa" [ngClass]="action.icon"></span>
        </span>
        <div class="pv2-create-card__text">
          <strong>{{ action.label }}</strong>
          <small>{{ action.description }}</small>
        </div>
      </button>
    </div>
  </section>

  <section class="pv2-sheet pv2-sheet--filters" *ngIf="advancedFiltersOpen">
    <div class="pv2-sheet-drag-handle"></div>
    <header>
      <div>
        <h3>Filtros avançados</h3>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheFiltrosAvancados()">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-adv-scroll">
      <div class="pv2-adv-section">
        <label class="pv2-adv-label">Status</label>
        <div class="pv2-adv-toggle-row">
          <button type="button" class="pv2-adv-toggle"
                  [class.is-active]="selectedStatusTab === 'sale'"
                  (click)="selectStatusTab(statusTabs[0])">
            Ativos <span *ngIf="statusTabs[0]">{{ statusTabs[0].count }}</span>
          </button>
          <button type="button" class="pv2-adv-toggle"
                  [class.is-active]="selectedStatusTab === 'unavailable'"
                  (click)="selectStatusTab(statusTabs[1])">
            Inativos <span *ngIf="statusTabs[1]">{{ statusTabs[1].count }}</span>
          </button>
        </div>
      </div>

      <div class="pv2-adv-section">
        <label class="pv2-adv-label">Ordenação</label>
        <select class="pv2-adv-select" [(ngModel)]="filterDraft.sortField">
          <option value="name">Nome {{ filterDraft.sortField === 'name' ? (filterDraft.sortDirection === 'asc' ? 'A-Z' : 'Z-A') : '' }}</option>
          <option value="price">Preço {{ filterDraft.sortField === 'price' ? (filterDraft.sortDirection === 'asc' ? '↑' : '↓') : '' }}</option>
        </select>
      </div>

      <div class="pv2-adv-section" *ngIf="disponibilidadesCatalogo.length">
        <label class="pv2-adv-label">Disponibilidade</label>
        <kendo-multiselect
          [data]="disponibilidadesCatalogo"
          textField="descricao"
          valueField="id"
          [(ngModel)]="filterDraft.disponibilidadeIds"
          placeholder="Selecione disponibilidades"
          [autoClose]="false"
        >
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <span>{{ dataItem.descricao }}</span>
          </ng-template>
        </kendo-multiselect>
      </div>

      <div class="pv2-adv-section">
        <label class="pv2-adv-check">
          <input type="checkbox" [(ngModel)]="filterDraft.semCodigoPdv">
          <span>Sem código de PDV</span>
        </label>
        <label class="pv2-adv-check">
          <input type="checkbox" [(ngModel)]="filterDraft.naoSincronizados">
          <span>Não sincronizados</span>
        </label>
      </div>

    </div>

    <footer class="pv2-sheet-footer">
      <button type="button" class="pv2-sheet-footer__clear" (click)="limpeFiltrosAvancados()">Limpar filtros</button>
      <button type="button" class="pv2-sheet-footer__apply" (click)="apliqueFiltrosAvancados()">Aplicar</button>
    </footer>
  </section>

  <section class="pv2-sheet pv2-sheet--categories" *ngIf="categorySheetOpen">
    <div class="pv2-sheet-drag-handle"></div>
    <header>
      <div>
        <h3>Selecionar Categoria</h3>
        <p class="pv2-sheet-subtitle">{{ filteredCategoryListInSheet.length }} categorias disponíveis</p>
      </div>
      <button type="button" class="pv2-card-menu" (click)="fecheCategoriaSheet()">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <label class="pv2-search pv2-search--sheet">
      <span class="fa fa-search"></span>
      <input
        [(ngModel)]="categorySheetSearch"
        type="text"
        placeholder="Buscar categoria..."
        inputmode="search">
    </label>

    <div class="pv2-category-radio-list">
      <label
        class="pv2-category-radio"
        *ngFor="let category of filteredCategoryListInSheet; trackBy: trackByLabel"
        [class.is-selected]="categorySheetSelected === category.nome">
        <input
          type="radio"
          name="categorySheetRadio"
          [value]="category.nome"
          [(ngModel)]="categorySheetSelected">
        <span class="pv2-category-radio__indicator"></span>
        <span class="pv2-category-radio__label">{{ category.nome }}</span>
        <span class="pv2-category-radio__count"
              [class.is-highlight]="category.nome === 'Todos'">{{ category.count }}</span>
      </label>
    </div>

    <footer class="pv2-sheet-footer">
      <button type="button" class="pv2-sheet-footer__clear" (click)="limparCategoriaSheet()">Limpar</button>
      <button type="button" class="pv2-sheet-footer__apply" (click)="apliqueCategoriaSheet()">Aplicar (1)</button>
    </footer>
  </section>
</div>
